<template>
  <div class="layout">
    <!-- 左侧导航 -->
    <aside class="sider" :class="{ collapsed: isCollapse }">
      <leftNav />
    </aside>

    <!-- 右侧内容 -->
    <section class="main-wrap">
      <header class="top-bar">
        <headers />
      </header>
      <main class="content">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath" />
        </transition>
      </main>
    </section>
  </div>
</template>

<script>
import leftNav from '@/components/leftNav.vue'
import headers from '@/components/header.vue'

export default {
  components: { leftNav, headers },
  computed: {
    isCollapse() {
      return this.$store.state.leftnav.isCollapse
    }
  }
}
</script>

<style scoped>
/* ========= 根布局：永远不再横向撑爆 ========= */
.layout {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;          /* 整页永不出现横向滚动条 */
}

/* 左侧导航：展开 200px，折叠 64px */
.sider {
  flex: 0 0 200px;
  height: 100vh;
  overflow-y: auto;
  background: #fff;
  transition: all 0.3s;
}
.sider.collapsed {
  flex: 0 0 64px;
}

/* 右侧容器：占满剩余宽度，且内部自己管滚动 */
.main-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;              /* 关键：允许比内容更窄 */
}

.top-bar {
  height: 55px;
  box-shadow: 0 1px 4px rgba(0,0,0,.08);
}

.content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;          /* 仅内容区纵向滚动 */
  overflow-x: hidden;        /* 内容区绝不横向滚 */
  background: #f5f5f5;
}
</style>

<style>
/* 你原来几千行全局样式，整段粘回来即可，一行都不用改 */
.odbtns .el-button { margin-left: 0; margin-bottom: 6px; }
.el-table td.el-table__cell div { color: #666 !important; }
.el-table th.el-table__cell > .cell { font-size: 12px !important; color: #333 !important; }
.order_table_td { padding: 10px 0 !important; }
.el-page-header__content { font-size: 14px; }
.el-breadcrumb__inner { color: #333; }
.el-dialog__wrapper { display: flex; align-items: center; }
.topnav { width: 100%; background: white; height: 60px; border: 1px solid #e0e0e0; margin-bottom: 10px; display: flex; align-items: center; justify-content: flex-end; }
.navico { width: 20px; height: 20px; cursor: pointer; }
.formbox { border: none; display: flex; align-items: center; justify-content: flex-end; padding: 16px 0; }
.card-title { font-size: 15px; font-weight: bold; }
.card-title2 { font-size: 14px; font-weight: bold; padding: 10px 0; }
.serinp { width: 300px; }
.serinp input { background: #F2F3F5; border: none; }
.serbtn { display: flex; align-items: center; font-size: 12px; color: #333; height: 32px; margin-left: 8px; border-radius: 5px; padding: 0 18px; cursor: pointer; }
.serbtn.add { color: #5B9DFF; background-color: #D1E3FF; }
.serbtn.del { color: #FF4036; background-color: #FFD8D6; }
.serbtn.re { color: #7DD454; background-color: #DDF4D2; }
.btnico { width: 16px; height: 16px; }
.droptext { font-size: 12px; color: #666; height: 30px; text-align: center; }
.droptext:hover { color: #1975FF }
.droptext.bor { border-bottom: 1px solid #f0f0f0; }
.info-row1 { width: 100%; }
.info-t1 { font-size: 12px; color: #999; display: inline-block; }
.info-t2 { font-size: 13px; color: #333; margin-left: 10px; }
.info-t3 { font-size: 13px; color: #333; padding-top: 4px; }
.info-row2 { width: 100%; display: flex; margin-top: 6px; }
.info-row3 { flex: 1; margin-left: 10px; display: flex; flex-direction: column; }
.info-row4 { width: 100%; height: 80px; margin-top: 6px; }
.mlab { color: white; background: #1975FF; border-radius: 5px; font-size: 11px; display: inline-block; width: 70px; text-align: center; }
page { font-size: 16px; }
.serbox { margin: 20px 0; }
.sercell { display: flex; align-items: center; }
.serlab { font-size: 14px; color: #555; width: 100px; }
.sercontent { flex: 1 }
.sercontent input { background: #F2F3F5; border: none; }
.serinp2 input { background: #F2F3F5; border: none; }
.serbtn2.re { color: #7DD454; background-color: #DDF4D2; }
.serbtn2 { display: flex; align-items: center; font-size: 13px; height: 32px; margin-left: 8px; border-radius: 5px; color: #666; background: #F2F3F5; justify-content: center; width: 90px; }
.serbtn2.on { color: white; background: #1975FF; }
.serbtn2.dc { color: white; background: #67C23A; }
.btnico2 { width: 16px; height: 16px; margin-right: 4px; }
.mbar { width: 100%; font-size: 13px; color: #666; display: flex; padding: 14px 0; }
.mtable { width: 100%; }
.width_5 { width: 1%; }
.width_95 { width: 99% }
.width_100 { width: 100% }
.tcell { width: 100%; display: flex; }
.tcell.center { align-items: center; border-bottom: 1px solid #f0f0f0; }
.tcell2 { font-size: 13px; color: #444; width: 100%; padding: 4px 0; }
.tspan { color: #888; font-size: 12px; margin-right: 10px; }
.tbox { width: 100%; margin-bottom: 10px; border: 1px solid #f0f0f0; }
.tbox:hover { background: #f8f8f8; }
.mtr { width: 100%; display: flex; }
.tpic { width: 60px; height: 60px; border-radius: 5px; }
.tcol { flex: 1; margin-left: 20px; }
.tlab { color: #999; }
.tcell3 { width: 100%; display: flex; padding: 10px 0; }
.ttag { font-size: 12px; border: 1px solid #0065FF; color: #0065FF; padding: 0 14px; border-radius: 5px; margin-right: 10px; height: 26px; display: flex; align-items: center; }
.ttag.on { border: 1px solid #FCBF68; color: #FCBF68; }
.topt { height: 26px; background: #0065FF; width: 100px; display: flex; align-items: center; justify-content: center; color: white; font-size: 12px; border-radius: 5px; cursor: pointer; }
.tico { width: 16px; height: 16px }
.thead { width: 100%; padding: 14px 0; display: flex; background: #F8F8F8; }
.tfooter { width: 98%; margin-left: 1%; padding: 10px 0; border-top: 1px solid #f0f0f0; }
.obox { width: 100%; display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr; grid-gap: 10px; padding: 10px 0 }
.obox2 { width: 100%; display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr; grid-gap: 10px; padding: 10px 0 }
.ot1 { color: #666; font-size: 13px; }
.ot2 { color: #888; font-size: 13px; }
.wlbox { width: 100%; background: #f8f8f8; padding: 10px 0; margin: 10px 0; }
.wlcell { width: 98%; margin-left: 1%; padding: 10px 0; grid-template-columns: 1fr 1fr 1fr 1fr 1fr; grid-gap: 10px; display: grid; }
.wlcell.bor { border-bottom: 1px solid #f0f0f0; }
.wltitle { width: 98%; margin-left: 1%; font-size: 14px; color: #333; font-weight: bold; padding: 10px 0; }
.wlbtns { width: 98%; margin-left: 1%; padding: 10px 0 }
.ids { width: 100%; margin: 10px 0; display: flex; }
.ids .idbox { width: 10vw; height: 6vw; background: white; border: 1px solid #e0e0e0; border-radius: 5px; margin-right: 20px; display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; flex-direction: column; }
.preimg { width: 100%; height: 100%; }
.updimg { width: 5vw; height: 3vw; }
.updtext { font-size: 12px; color: #777; margin-top: 4px; }
.updarea { display: flex; align-items: center; justify-content: center; flex-direction: column; }
.sico { width: 14px; height: 14px; margin-right: 4px; }
.sico2 { width: 50px; }
.mtag { color: #333; font-size: 14px; display: flex; align-items: center; }
.ginp input { background: #F2F3F5; border: none !important; width: 400px; }
.el-cascader .el-input input { background: #F2F3F5; border: none; }
.formbar { font-size: 16px; color: #666; width: 100%; display: flex; padding: 10px 0; align-items: center; }
.el-upload--picture-card { border: none; background: #F2F3F5; width: 140px; height: 140px; }
.el-upload-list--picture-card .el-upload-list__item { width: 140px; height: 140px; }
.el-notification {}
.el-header { padding: 0 !important; height: auto !important; }
.el-main { height: calc(100vh - 130px); background: #F5F5F5; }
</style>